import API from "@/global/request/api";
import request from "@/global/request/request";

const kcellService = {
  kcellSkills(params = {}) {
    return request.get(API.kcellSkills, params);
  },
  kcellIndustry() {
    return request.get(API.kcellIndustry);
  },
  kcellPositionsAll(params = {}) {
    const data = sessionStorage.getItem("API.kcellPositionsAll");
    return data
      ? Promise.resolve(JSON.parse(data))
      : request.get(API.kcellPositionsAll, params).then(res => {
          const str = JSON.stringify(res);
          sessionStorage.setItem("API.kcellPositionsAll", str);
          return res;
        });
  },
  kcellPositionsSkillModel(id, params = {}) {
    return request.get(API.kcellPositionsSkillModel(id), params);
  },
  kcellIndustryList() {
    return request.get(API.kcellIndustry);
  }
};

export default kcellService;
